import { configureStore } from '@reduxjs/toolkit';
import produce from 'immer';
import { createSelector } from 'reselect';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import './styles.css';  // Assuming global styles are in this file

// Initial State
const initialState = {
  entities: {
    items: {
      byId: {
        1: { id: 1, name: 'Item 1', value: 10 },
        2: { id: 2, name: 'Item 2', value: 20 }
      },
      allIds: [1, 2]
    }
  },
  mything: 'Initial Value'
};

// Root Reducer
const rootReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case 'UPDATE_ITEM':
        const item = draft.entities.items.byId[action.payload.id];
        if (item) {
          item.value = action.payload.value;
        }
        break;
      case 'UPDATE_MYTHING':
        draft.mything = action.payload;
        break;
      default:
        break;
    }
  });
};

// Configure Store
const store = configureStore({
  reducer: rootReducer
});

// Render Application
const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root')
  );
};

render();

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./App', () => {
    render();
  });
}
